var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bfiles&&_vm.bfiles.length)?_c('div',_vm._l((_vm.bfiles),function(item,index){return _c('v-btn',{key:index,attrs:{"text":""},on:{"click":function($event){return _vm.downloadFile(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }